import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=512d6b75&scoped=true"
import script from "./IconsList.vue?vue&type=script&lang=js"
export * from "./IconsList.vue?vue&type=script&lang=js"
import style0 from "./IconsList.vue?vue&type=style&index=0&id=512d6b75&prod&scoped=true&lang=css"
import style1 from "./IconsList.vue?vue&type=style&index=1&id=512d6b75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d6b75",
  null
  
)

export default component.exports